import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import FloatingButton from './components/FloatingButton';
import Login from './pages/Login';
import Home from './pages/Home';
import Users from './pages/Users';
import Clients from './pages/Clients';
import Projects from './pages/Projects';
import WorklogView from './pages/WorklogView';
import Bitacora from './pages/Bitacora';
import AdminWorklogApproval from './pages/AdminWorklogApproval';
import { useAuth } from './context/AuthContext';

export default function App() {
  const { user } = useAuth();

  return (
    <>
      <Routes>
        {/* Ruta pública */}
        <Route path="/login" element={<Login />} />

        {/* RUTAS PROTEGIDAS (Cualquier usuario logueado) */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/bitacora" element={<Bitacora />} />
          <Route path="/worklog/:projectId" element={<WorklogView />} />
          <Route path="/worklog" element={<WorklogView />} />
        </Route>

        {/* RUTAS DE ADMINISTRADOR */}
        <Route element={<ProtectedRoute roles={['admin']} />}>
          <Route path="/users" element={<Users />} />
          <Route path="/approvals" element={<AdminWorklogApproval />} />
        </Route>

        {/* Redirección final: si no coincide nada, al Home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {user && <FloatingButton />}
    </>
  );
}